// extracted by mini-css-extract-plugin
export default {"BookingFrame":"Reservaciones_BookingFrame__VfrXB"};